/**
 * Service: AuditTrailService
 */
angular.module('acme.common.service.auditTrail', [
  'acme.common.service.helpers',
  'acme.common.service.auditTrailVersionHandler',
  'acme.common.service.auditTrailColumnGenerator',
  'acme.common.service.auditTrailGrids'
])
.service('AuditTrailService', ['AuditTrailVersionHandlerService', 'HelpersService', 'AuditTrailColumnGenerator', 'AuditTrailGridsService', 'AuditTrailConfigsService', 'TemplatesService', 'TemplatesHelpersService', 'FlexpayService', '$filter', function(AuditTrailVersionHandlerService, HelpersService, AuditTrailColumnGenerator, AuditTrailGridsService, AuditTrailConfigsService, TemplatesService, TemplatesHelpersService, FlexpayService, $filter) {
    
    return {
      
      ID: '',
      version: {},
      config: AuditTrailConfigsService,  
      versionHandler: AuditTrailVersionHandlerService,
      grids: AuditTrailGridsService,
      path: '',
      tempGridObj: { 
        headers: [], 
        updated: [], 
        original: [], 
        newValues: [],
        removed: []
      },
      
      init: function(id, model, path) {
        this.ID  = id;
        this.config.init(path);
        this.path = path;
        this.setVersionModel(model);
      },

      setVersionModel: function (model) {
        //rename addOn in combo history to avoid type conflict
        if (/combo.event.template/.test(model.auditTrail.businessEvent)) {
            if (model.patchedDiff.addOns) {
                model.patchedDiff.addOnsCombo = model.patchedDiff.addOns;
                delete model.patchedDiff.addOns;
            }

            if (model.actual.addOns) {
                model.actual.addOnsCombo = model.actual.addOns;
                delete model.actual.addOns;
            }
        }

        if(model.diff === null) {
          this.versionHandler.setNewVersion(model);
          this.version = this.versionHandler.getVersion();
          this.version.isEmpty = true;
        } else {
          this.versionHandler.setNewVersion(model);
          this.version = this.versionHandler.getVersion();
          this.version.isEmpty = false;
          this.processDiffObject();
          this.processGrids();
          this.setGridOptions();
        }
      },
      
      setGridOptions: function () {
        var key,
            i, ii, 
            builtGridOption,
            options = Object.create(null);
            
        if(this.version.grids.length) {
          for (i=0,ii=this.version.grids.length;i<ii; i++) {
            options = this.generateGridColumns();
          }
          for(key in options) {
            builtGridOption = this.config.buildGridOptions(options[key]);
            this.version.gridOptions.push(builtGridOption);
          }
        }
      },
            
      getVersionModel: function () {
        return this.version;
      },
      
      generateGridColumns: function () {
        var i, ii,
            k, kk,
            header,
            columns = {},
            self = this;
        
        for (k=0,kk=this.version.grids.length;k<kk; k++) {
          for (i=0,ii=this.version.grids[k].headers.length;i<ii; i++) {
            if(!columns[k]) {
              columns[k] = [];
            }
            columns[k].push({
              headerName: this.version.grids[k].headers[i],
              valueGetter: 'data[col'+[i]+']',
              cellStyle: AuditTrailColumnGenerator.getCellStyle(),
              cellRenderer: AuditTrailColumnGenerator.getCellRenderer()
            });
          } 
        } 
        
        return columns;
      },
      
      processDiffObject: function (diff) {
        var i, ii,
          groups = this.filterDiffGroups(this.version.diff.groups),
          group;
        
        for (i=0,ii=groups.length;i<ii; i++) {
          group = groups[i];
          if(group.fields) {
            this.processFields(group);
          }
          if (group.images) {
            this.processImages(group);
          }
        }     
      },
      
      filterDiffGroups: function(groups) {
        var r = [];
        if (groups.length) {
          r = groups.filter(function(item) {
            // schedules comes from patchedDiff,
            // and needs to be removed it from diff prop to avoid info redundance
            if (item.name !== 'schedule') {
              return item;
            }
          });
        }
        return r;
      },

      processFields: function (group) {
        var i, ii,
            option,
            fields = group.fields;
         
         for(i=0,ii=fields.length;i<ii;i++) {
           option = fields[i].op;
           field = fields[i];
           if (option === 'add') {
             group.fields[i].oldValue = 'New';
             group.fields[i].value = this.processFieldValue(field.value);
           } else if (HelpersService.validISODate(field.oldValue)) {
             group.fields[i].value = $filter('date')(field.value, HelpersService.dateFormats.fieldDate);
             group.fields[i].oldValue = $filter('date')(field.oldValue, HelpersService.dateFormats.fieldDate);
           }
         }
         this.versionHandler.addToVersion('tables', group);
      },

      processFieldValue: function(value) {
        var r = value,
            items = [];

        if (typeof value === 'object') {
          r = this.iterateFieldValueObj(value).join(', ');
        }

        if (HelpersService.validISODate(value)) {
          r = $filter('date')(value, HelpersService.dateFormats.fieldDate);
        }

        return r;
      },

      iterateFieldValueObj: function iterate(obj) {
        var r = [];

        for (var property in obj) {
          if (obj.hasOwnProperty(property)) {
            if (typeof obj[property] === "object") {
              r = this.iterateFieldValueObj(obj[property]);
            }
            else {
              r.push(property + ': ' + obj[property]);
            }
          }
        }

        return r;
      },

      processImages: function (group) {
        var i, ii, 
            headers, idxPrimary,
            images = group.images;
         
         for(i=0,ii=images.length;i<ii;i++) {
           
           headers = images[i].headers;
           idxPrimary  = headers.indexOf('Primary');
           
           if(images[i].deletedValue.length) {
             this.processImageValues(images[i].deletedValue, images[i], idxPrimary, 'removed');
           }
           if(images[i].updatedValues.length) {
             this.processImageValues(images[i].updatedValues, images[i], idxPrimary, 'replaced');
           }       
           if(images[i].newValues.length) {
             this.processImageValues(images[i].newValues, images[i], idxPrimary, 'newValues');
           }
           this.versionHandler.addToVersion('images', {
             original: this.tempGridObj.original, 
             updated: this.tempGridObj.updated, 
             newValues: this.tempGridObj.newValues,
             removed: this.tempGridObj.removed,
             breadcrumb: group.breadcrumb
           });
           this.resetTempGrid();
         }
      },
      
      processImageValues: function (dataset, grid, idx, status) {
        var i, ii;
        
        for (i=0,ii=dataset.length;i<ii; i++) {
          if(status === 'removed') {       
            this.tempGridObj.removed.push({
              id: grid.oldValues[dataset[i]][0],
              preview: grid.oldValues[dataset[i]].pop(),
              primary: (idx <= 0) ? grid.oldValues[dataset[i]][idx] : false
            });
          }
          if(status === 'newValues') {
            this.tempGridObj.newValues.push({
              id: dataset[i][0],
              preview: dataset[i].pop(),
              primary: (idx <= 0) ? dataset[i][idx] : false
            });
          }
          if(status === 'replaced') {
            this.tempGridObj.newValues.push({
              id: grid.updatedValues[i][0],
              preview: grid.updatedValues[i].pop(),
              primary: (idx <= 0) ? dataset[i][idx] : false
            });
          }
        }
      },
      
      processGrids: function () {
        var i, ii, 
            type, 
            updated, 
            original,
            _updated = this.version.updated,
            _original = this.version.original,
            keys = Object.keys(this.version.patchedDiff);
        
        for (i=0,ii=keys.length;i<ii; i++) {
          type = keys[i];
          if(this.config.storage[type]) {
            updated = _updated[type];
            original = _original[type];
            this.grids.processGridType(updated, original, type);
          }
        }
      },
            
      resetTempGrid: function () {
        this.tempGridObj.original = [];           
        this.tempGridObj.updated = []; 
        this.tempGridObj.newValues = [];
        this.tempGridObj.removed = [];
      },
      
      resetVersionModel: function () {
        this.version = {};
        this.versionHandler.reset();
      }
    };
}]);